import styled from "styled-components";

export const SpanTitulo = styled.span`
  color: #024634;
  font-size: 38px;
  font-weight: bold;
  width: 80%;
`;

export const SpanTexto = styled.span`
  color: #024634;
  font-size: 18px;
  margin-bottom: 15px;
`;

export const SpanTextoNegrito = styled.span`
  color: #024634;
  font-size: 18px;
  margin-bottom: 15px;
  font-weight: bold;
`;

export const DivGeral = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const CardConteudoSobre = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  background-color: white;
  border-radius: 10px;
  width: 90%;
  height: calc(100vh - 200px);
  overflow: auto;
`;

export const ImageLogosConainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-left: 30px;
`;
